import "@/App.css";
import "@/index.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Questionnaire from "@/pages/Questionnaire";
import Recommendations from "@/pages/Recommendations";
import Dashboard from "@/pages/Dashboard";
import Tracker from "@/pages/Tracker";
import Settings from "@/pages/Settings";
import SupplementDetail from "@/pages/SupplementDetail";
import SharedView from "@/pages/SharedView";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Founder from "@/pages/Founder";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import CookieConsent from "@/components/CookieConsent";
import { captureSourceOnce } from "@/lib/source";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <main className="min-h-[60vh] flex items-center justify-center">
        <p style={{ color: "var(--text-2)" }}>Loading…</p>
      </main>
    );
  }
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}

function Shell() {
  useEffect(() => {
    captureSourceOnce();
  }, []);
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/auth" element={<Auth />} />
        <Route
          path="/questionnaire"
          element={
            <Protected>
              <Questionnaire />
            </Protected>
          }
        />
        <Route
          path="/recommendations/:id"
          element={
            <Protected>
              <Recommendations />
            </Protected>
          }
        />
        <Route
          path="/dashboard"
          element={
            <Protected>
              <Dashboard />
            </Protected>
          }
        />
        <Route
          path="/tracker"
          element={
            <Protected>
              <Tracker />
            </Protected>
          }
        />
        <Route
          path="/settings"
          element={
            <Protected>
              <Settings />
            </Protected>
          }
        />
        <Route path="/supplements/:key" element={<SupplementDetail />} />
        <Route path="/share/:token" element={<SharedView />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="/founder"
          element={
            <Protected>
              <Founder />
            </Protected>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#FDFBF7",
            color: "#2A332B",
            border: "1px solid #E6E2D8",
            fontFamily: "Work Sans, sans-serif",
          },
        }}
      />
      <CookieConsent />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Shell />
      </AuthProvider>
    </BrowserRouter>
  );
}
